module.exports = __webpack_public_path__ + "static/media/IMG_0808.4ba60053.jpg";